var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6 8.40003C25.2 10.4 10.4 25.2 8.40001 43.2C6.40001 62 17.2 78.8 33.6 85.2C34.8 85.6 36 84.8 36 83.2V76.8C36 76.8 34.4 77.2 32.4 77.2C26.8 77.2 24.4 72.4 24 69.6C23.6 68 22.8 66.8 21.6 65.6C20.4 65.2 20 65.2 20 64.8C20 64 21.2 64 21.6 64C24 64 26 66.8 26.8 68C28.8 71.2 31.2 72 32.4 72C34 72 35.2 71.6 36 71.2C36.4 68.4 37.6 65.6 40 64C30.8 62 24 56.8 24 48C24 43.6 26 39.2 28.8 36C28.4 35.2 28 33.2 28 30.4C28 28.8 28 26.4 29.2 24C29.2 24 34.8 24 40.4 29.2C42.4 28.4 45.2 28 48 28C50.8 28 53.6 28.4 56 29.2C61.2 24 67.2 24 67.2 24C68 26.4 68 28.8 68 30.4C68 33.6 67.6 35.2 67.2 36C70 39.2 72 43.2 72 48C72 56.8 65.2 62 56 64C58.4 66 60 69.6 60 73.2V83.6C60 84.8 61.2 86 62.8 85.6C77.6 79.6 88 65.2 88 48.4C88 24.4 67.6 5.60003 43.6 8.40003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.15c02dd645f218147379fea243e80cfd.svg";
export { ForwardRef as ReactComponent };